/* UploadFile.tsx */
import UploadFilecss from "./UploadFile.module.css";
import { useRef, useState } from "react";
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';

interface UploadFileProps {
  title: React.ReactNode;
  required: boolean;
  fileFor: string;
  orgCreationToken: string;
  setFile: (file: File | null) => void;
}

export function UploadFile({
  title,
  required,
  fileFor,
  orgCreationToken,
  setFile,
}: UploadFileProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [dragActive, setDragActive] = useState(false);

  const handleFileInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setSelectedFile(file);
    setFile(file);
  };

  const handleRemoveFile = () => {
    setSelectedFile(null);
    setFile(null);
    if (inputRef.current) inputRef.current.value = "";
  };

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(true);
  };
  const handleDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
  };
  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    const file = e.dataTransfer.files?.[0];
    if (file) {
      setSelectedFile(file);
      setFile(file);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div className={UploadFilecss.uploadComponent}>
      <p className={UploadFilecss.fileTitle}>{title}</p>
      <div
        className={dragActive ? `${UploadFilecss.chooseFileButton} ${UploadFilecss.dragActive}` : UploadFilecss.chooseFileButton}
        tabIndex={0}
        aria-label="Select file to upload"
        onClick={() => inputRef.current?.click()}
        onKeyPress={e => (e.key === 'Enter' || e.key === ' ') && inputRef.current?.click()}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        role="button"
      >
        <span className={UploadFilecss.fileIcon} aria-hidden="true">
          <InsertDriveFileIcon fontSize="inherit" />
        </span>
        <span>{selectedFile ? 'Change file' : 'Select file'}</span>
        <input
          ref={inputRef}
          style={{ display: 'none' }}
          type="file"
          name={fileFor}
          required={required && !selectedFile}
          onChange={handleFileInput}
          tabIndex={-1}
        />
        {selectedFile && (
          <span className={UploadFilecss.selectedFileName}>
            {selectedFile.name}
            <button
              type="button"
              className={UploadFilecss.removeFileBtn}
              aria-label="Remove file"
              onClick={e => { e.stopPropagation(); handleRemoveFile(); }}
            >
              ×
            </button>
          </span>
        )}
      </div>
    </div>
  );
}
